export default import.meta.ROLLUP_FILE_URL_BwqcWk9t;